import { j as t } from "./jsx-runtime-DmTjM30f.js";
import { B as e } from "./index.esm-G8KyR0tM.js";
import { L as i } from "./LanguageSelector-Cxyk2l5L.js";
import { i as a } from "./index-wI714H_N.js";
function x({ onAck: r, welcomeSteps: s }) {
  return /* @__PURE__ */ t.jsxs(t.Fragment, {
    children: [
      /* @__PURE__ */ t.jsx("ol", {
        className: "text-neutral dark:text-neutral-dark-110 font-opensans list-decimal px-4 font-semibold",
        children: s.map((n) => {
          const o = n.content;
          return /* @__PURE__ */ t.jsx("li", {
            children: o
          }, n.step);
        })
      }),
      /* @__PURE__ */ t.jsx(i, {}),
      /* @__PURE__ */ t.jsx(e, {
        onClick: r,
        fullwidth: !0,
        customClass: "mb-8",
        children: a._({
          id: "2iVSoY"
        })
      })
    ]
  });
}
export {
  x as W
};
